import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../comman/SnackBarUI'
import { deleteMissionAction } from '../../redux/toolkit/mission/deleteMission'
import { getMissionAction } from '../../redux/toolkit/mission/getMission'
import PropTypes from 'prop-types';


export default function DeleteMission({ mission_id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const delMission = useSelector(state => state.deleteMission)
    const { status, message } = delMission

    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)
    }

    const delCatHandle = async () => {
        const deleteMissionData = await dispatch(deleteMissionAction(mission_id))
        if (deleteMissionData?.payload?.status == 201) {
            await dispatch(getMissionAction({ is_deleted: false }))
        }
        setSnack(true)
        setState(false)
    }

    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Deleting request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete the selected item ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={delCatHandle} autoFocus> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>


            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>

    )
}

DeleteMission.propTypes = {
    mission_id: PropTypes.string,
    state: PropTypes.any,
    setState: PropTypes.any
};
